// Called by : src/App.vue (router-view)

<template>
    <div id="page_list" v-cloak>

        {{ forceUpdate }}

        <h1 id="page_list_title" class="page_title mb-4 px-2">

          <div class="btn-group float-right ml-2 mt-2">
            <button class="ui_tip btn btn-light" style="border:1px solid #ced4da !important;" v-bind:title="tipFoldUnfold" @click="setFoldUnfoldCours"><span class="oi oi-elevator"></span></button>
            <button class="ui_tip btn btn-light" style="border:1px solid #ced4da !important;" v-bind:title="tipFoldUnfold" @click="setFoldUnfoldAll"><span class="oi oi-elevator"></span></button>
          </div>

          <small class="col-3 float-right mt-2 mx-0 px-0 d-none d-lg-inline">
            <a href="#" id="erase_filter" v-bind:title="labelErase" class="ui_tip btn position-absolute py-0 px-2" v-on:click="eraseFilter">
              <span class="text-danger txt_size_150">&times;</span>
            </a>
            <input type="text" id="filter" class="form-control" v-bind:placeholder="labelFilter" @input="applyFilter">
          </small>

          {{ params.assignmentTitle }}
          
          <small class="col-12 mt-4 mx-0 px-0 d-block d-lg-none">
            <a href="#" id="erase_filter" v-bind:title="labelErase" class="ui_tip btn position-absolute py-0 px-2" v-on:click="eraseFilter">
              <span class="text-danger txt_size_150">&times;</span>
            </a>
            <input type="text" id="filter" class="form-control" v-bind:placeholder="labelFilter" @input="applyFilter" />
          </small>

        </h1> <!-- #page_list_title -->
        
        <div id="page_list_body">

          <div class="alert alert-warning" v-if="errorMsg">{{ errorMsg }}</div>

          <div v-if="trainsNbr">
            <vsa-list :auto-collapse="false" :force-active="false" :key="componentKey">
              <train-item v-for="train in trains" :key="train.zkp" :train="train" />
            </vsa-list>
          </div>
          <div v-else class="data_wait text-secondary text-center h5 w-100" :style="loader">
            {{ dataWait }}
          </div>

        </div> <!-- #page_list_body -->
      
        <div id="page_list_footer" class="col-12 mt-2 p-2 text-right fond_clair">

          <span class="btn">&nbsp;</span>
          <button v-if="params.canResetLesson" class="ui_tip btn btn-outline-dark px-4 mr-3 d-none" @click="resetAllLesson()" v-bind:title="tipLessonInitAll">
            <span class="oi oi-loop-circular mr-2"></span>
            {{ labelLessonInitAll }}
          </button>
          
        </div> <!-- #page_list_footer -->

    </div> <!-- #page_list --> 
</template>

<script>
import { constants } from '@/constants'
import TrainItem from '@/components/lesson/TrainItem'
import SelectLocale from '@/components/header/SelectLocale'

import {
  VsaList,
  VsaItem,
  VsaHeading,
  VsaContent,
  VsaIcon,
} from 'vue-simple-accordion'
import 'vue-simple-accordion/dist/vue-simple-accordion.css'

export default {
  name: 'AssignmentsList',
  components: {
    TrainItem,
    VsaList,
    VsaItem,
    VsaHeading,
    VsaContent,
    VsaIcon,
    SelectLocale,
  },
  data() {
    return {
      val: '',
      misc: '',
      trains: [],
      trainsNbr: 0,
      filter: '',
      errorMsg: '',
      componentKey: 0,
      labelFilter: '',
      labelErase: '',
      loader: '',
      dataWait: '',
      labelLessonInitAll: this.$t('assignments.labelLessonInitAll'),
      tipLessonInitAll: this.$t('assignments.tipLessonInitAll'),
      tipFoldUnfold: this.$t('assignments.tipFoldUnfold'),
    }
  },
  methods: {
    test() {
      this.model.test()
    },
    waitData() {
      var nTime = 30000; // 1000 = 1 sec ; 10000 = 10 sec; 
      var sText = this.$t('assignments.noLessonFound');
      var oThis = this;
      setTimeout(function () {
        oThis.dataWait = sText;
        oThis.loader = '';
      }, nTime);
    },
    getKey(sId) {
      return sId + f_getRandomMinMax_n(100000000, 999999999);
    },
    getAssignments() {

      // console.log('isAssign', this.isAssignments.toString());
      // console.log('isAssign', this.$store.state.isAssignments.toString());
      // console.log('assignUser', this.$store.state.user);
      this.waitData();

    // !!! Fredo 25/11/2023 : on reviens au fonctionnement initial
    this.model.getAssignments(this.user.zkp)
      .then((lessonSuccess) => {
        this.trains = lessonSuccess.assignments;
        this.trainsNbr = this.trains.length;
        this.$store.commit('setAssignments', lessonSuccess.assignments);
        this.$store.commit('setQuestionsPreload', []);
        // console.error('assignments : ', lessonSuccess.assignments);
        // console.log("lecName", this.trains[0].courses[0].lessons[0].name);
        // {{ trains[0].courses[0].lessons[0].name }}
      })
      .catch((lessonError) => {
        console.error('lessonError : ', lessonError)
        this.errorMsg = lessonError.messages[0].message        
      })

      this.labelFilter = this.$t("assignments.labelFilter")
    },
    setFoldUnfoldAll() {
      $('button.vsa-item__trigger').click();
      // if ($('div.vsa-item').hasClass('vsa-item--is-active'))
    },
    setFoldUnfoldCours() {
      $('dd.vsa-item__content button.vsa-item__trigger').click();
    },
    applyFilter(val) {
      this.val = val;
      this.filter = val.target.value
      this.trains.forEach((train) => {
        train.courses.forEach((course) => {
          course.lessons.forEach((lesson) => {
            lesson.visible = lesson.name.toLowerCase().indexOf(this.filter.toLowerCase()) !== -1
          })
        })
      })
      this.componentKey++
    },
    eraseFilter() {
      this.val.target.value = '';
      this.applyFilter(this.val);
    },
    resetAllLesson() {
      // this.model.runScript('LAPR_js', '2022_VUEJS_LeconsToutes_Init', this.user.zkp)
      // this.model.getAssignments(this.user.zkp)
      // this.$router.push({ name: 'patience', params: { lesson: null, }})
   },
    closeMisc() {
      this.misc = ''
    },
  }, // methods
  computed: {
    user() {
      return this.$store.state.user
    },
    model() {
      return this.$store.state.model
    },
    params() {
      return this.$store.state.params
    },  
    tokens() {
      return this.$store.state.tokens
    },  
    assignments() {
      return this.$store.state.assignments
    },  
    isAssignments() {
      return this.$store.state.isAssignments
    },  
    forceUpdate() {
      this.labelFilter = this.$t("assignments.labelFilter");
      this.labelErase = this.$t("assignments.labelErase");
      this.labelLessonInitAll = this.$t('assignments.labelLessonInitAll');
      this.tipLessonInitAll = this.$t('assignments.tipLessonInitAll');
      this.tipFoldUnfold = this.$t('assignments.tipFoldUnfold');
      if (this.filter) {
        $('#page_list_title #erase_filter').show();
      } else {
        $('#page_list_title #erase_filter').hide();
      }
      return '';
    },
  },
  mounted: function() {
    // On affiche la roue d'attente…
    this.dataWait = this.$t("assignments.dataWait");
    this.loader = "background-image: url(" + constants.assets.load_5bc + ");";

    // On récupère toute la liste des leçons…
    this.getAssignments();

    /*
      On gère l'affichage auto des modales suivant les paramètres 
      Dans App.vue on gère le "z-index" lorsqu'il y a plusieurs modales affichées, 
      en mettant toujours les CGU en premier, puis les infos apprenant et enfin la signature.
      De plus, dans "styles.css" on règle les fonds gris pour que seulement le dernier reste affiché.
      (on aurait pu regrouper tout ça dans les styles…)
    */

    var isCgu = Boolean(!this.user.cguOk);
    var isSign = Boolean(this.params.isSignature && this.params.isSignShowAuto && !this.user.signOk);
    var isPerso = Boolean(this.user.persoIdnOk);
    var isIdn = Boolean(this.user.newIdnOk);
    var isApr = Boolean(isPerso && !isIdn);

    if (isCgu) {
      document.getElementById('btn_pge_cgu').click();
    };
    if (isApr) {
      document.getElementById('btn_pge_apr').click();
    };
    if (isSign) {
      document.getElementById('btn_pge_sign').click();
    };

    // console.log('🔵🔵🔵-tokens',this.tokens);
    // console.log('🔵🔵🔵-localStorage',localStorage);
  
  },

}
</script>

<style scoped>
.data_wait {
  height: 200px !important;
  background-position: center 50px;
  background-repeat: no-repeat;
  background-size: auto;
}
#erase_filter {
  top: -2px;
  right: 4px;
  outline: none;
  display: none;
}
#page_list_footer {
  background-color: #aaa;
  /* .bg-secondary = #6c757d */
}
#page_list_footer.fond_clair {
  background-color: #ddd;
}
</style>


// WEBPACK FOOTER //
// src/components/lesson/AssignmentsList.vue